export const urlToFilesName = (url: string) => {
  try {
    return url.replace(/^.*[\\\/]/, "");
  } catch (error) {
    return "";
  }
};
